import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface SplashScreenProps {
  onEnter: () => void;
}
export function SplashScreen({
  onEnter
}: SplashScreenProps) {
  const [dollars, setDollars] = useState<Array<{
    id: number;
    x: number;
    delay: number;
    duration: number;
    direction: number;
    opacity: number;
    fontSize: number;
  }>>([]);
  useEffect(() => {
    const newDollars = Array.from({
      length: 40
    }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      delay: Math.random() * 1.5,
      duration: 5 + Math.random() * 10,
      direction: Math.random() > 0.5 ? 1 : -1,
      opacity: 0.25 + Math.random() * 0.35,
      fontSize: 30 + Math.random() * 50
    }));
    setDollars(newDollars);
  }, []);
  return <motion.div initial={{
    opacity: 1
  }} exit={{
    opacity: 0,
    y: -50,
    transition: {
      duration: 0.8,
      ease: 'easeInOut'
    }
  }} className="fixed inset-0 z-[100] bg-black flex flex-col items-center justify-center overflow-hidden" data-id="element-304">
      {/* Animated Dollar Signs Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-305">
        {dollars.map(dollar => <motion.div key={dollar.id} initial={{
        y: dollar.direction === 1 ? -100 : '110vh',
        opacity: 0
      }} animate={{
        y: dollar.direction === 1 ? '110vh' : -100,
        opacity: [0, dollar.opacity, dollar.opacity, 0]
      }} transition={{
        duration: dollar.duration,
        repeat: Infinity,
        delay: dollar.delay,
        ease: 'linear'
      }} className="absolute text-green-400 font-bold select-none" style={{
        left: `${dollar.x}%`,
        fontSize: `${dollar.fontSize}px`
      }} data-id="element-306">
            $
          </motion.div>)}
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-307">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-308">
          <h1 className="font-display font-bold text-4xl md:text-6xl lg:text-7xl text-white leading-tight mb-8 uppercase" data-id="element-309">
            ¿Estás listo para generar <br data-id="element-310" />
            <span className="text-brand-yellow inline-block mt-2" data-id="element-311">
              Miles ($$$$)
            </span>{' '}
            <br data-id="element-312" />
            por semana?
          </h1>

          <motion.button onClick={onEnter} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="group relative inline-flex items-center gap-3 bg-brand-yellow hover:bg-brand-yellowHover text-black font-display font-bold text-2xl md:text-3xl uppercase py-6 px-12 rounded-xl shadow-[0_0_40px_rgba(234,179,8,0.4)] hover:shadow-[0_0_60px_rgba(234,179,8,0.6)] transition-all" data-id="element-313">
            <span data-id="element-314">¡Claro que sí!</span>
            <ArrowRight className="w-8 h-8 group-hover:translate-x-1 transition-transform" strokeWidth={3} data-id="element-315" />
            <div className="absolute inset-0 rounded-xl ring-2 ring-white/50 animate-pulse" data-id="element-316" />
          </motion.button>
        </motion.div>
      </div>
    </motion.div>;
}